import React, { useContext, useEffect, useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import { Box, Button, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import RtlProvider from "../../../Components/RtlProvider";
import colorApi from "../../../api/colorApi";
import { ContextNotification, severitys } from "../../../App";

import { ContextUserInfo } from "../MainPanel";
import AccessControl from "../../../Components/AccessControl";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import DeleteColorForm from "./DeleteColorForm";
import { MdEdit, MdEditSquare } from "react-icons/md";



const ColorPanel = () => {
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  const { open, setOpen } = useContext(ContextNotification);
  // const [rows, setRows] = useState([]);
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(false);
  const [loadingRows, setLoadingRows] = useState(false);

  useEffect(() => {
    GetData();
  }, [refresh]);
  const RefreshGrid = (result) => {
    if (result)
      setRefresh(old => !old);
  }
  const GetData = () => {
    setLoadingRows(true);
    colorApi.GetForUser()
      .then((data) => {
        setData(data.data.data)
      })
      .catch((error) => console.log(error))
      .finally(() => setLoadingRows(false));
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: 'colorName',
        header: 'نام',
        size: 100,
      },
      {
        accessorKey: 'color',
        id: 'color',
        header: 'رنگ',
        size: 150,
        Cell: ({ cell, row }) => (
          <Box
            sx={{
              width: 20,
              height: 20,
              borderRadius: 1,
              bgcolor: row.original.colorCode
            }}
          />
        ),
        enableSorting: false,
      },
      {
        accessorKey: 'planCodePersian',
        header: 'کد پلان',
        size: 100,
      },

    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data,
    initialState: {
      sorting: [

      ],
    },
    state: {
      isLoading: loadingRows,
    },
    enableRowSelection: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enablePagination: false,
    enableSorting: true,
    enableColumnActions: false,

    mrtTheme: (theme) => ({
      baseBackgroundColor: theme.palette.background.default, //change default background color
    }),

    muiTableProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',

      },
    },
    muiTableHeadCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        backgroundColor: '#86A7FC',
        fontWeight: 'bold',
        textAlign: 'left'
      },
    },
    muiTableBodyCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        textAlign: 'left'
      },
    },
    enableRowActions: true,
    positionActionsColumn: 'last',
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: '', //change header text
        size: 300, //make actions column wider

      },
    },
    renderRowActions: ({ row, table }) => (

      <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
        {
          AccessControl.checkPermissions(userPermissions, ["Color:Edit"]) ?
            <Tooltip title="ویرایش" placement="top">
              <IconButton disabled={row.original.isDeleted}
                component={NavLink} to={`/dashboard/Color/edit/${row.original.id}`} sx={{ color: 'IconColor.main' }}><MdEditSquare />
              </IconButton>
            </Tooltip>
            : <></>
        }
        {
          AccessControl.checkPermissions(userPermissions, ["Color:Delete"]) &&
          <DeleteColorForm id={row.original.id} refreshGrid={RefreshGrid} />}

      </Box>
    ),
  });


  return (
    <RtlProvider>
      <Typography component="h1" variant="h5" mb={2}>
        لیست پلان کد
      </Typography>
      <MaterialReactTable table={table} />
    </RtlProvider>
  );
}

export default ColorPanel;
